export default "__VITE_ASSET__BoKAxGEn__"